import { t } from '@i18n';
import { language_enum } from '@predium/enums';
import { COMMON_DATE_FORMATS, formatDateToLocale, Localize } from '@predium/utils';
import { setLocale } from 'yup';

export const setYupLocale = ({ localize, language }: { localize: Localize; language: language_enum }) => {
  const required = t('General_Required');

  setLocale({
    mixed: {
      required,
      oneOf: required,
    },
    string: {
      max: t('Validation_StringMaxLength'),
    },
    number: {
      min: ({ min }) => t('Validation_NumberMin', { min: localize.formatAsFloat(min) }),
      moreThan: ({ more }) => t('Validation_NumberMoreThan', { more: localize.formatAsFloat(more) }),
      max: ({ max }) => t('Validation_NumberMax', { max: localize.formatAsFloat(max) }),
      lessThan: ({ less }) => t('Validation_NumberLessThan', { less: localize.formatAsFloat(less) }),
      positive: ({ more }) => t('Validation_NumberMoreThan', { more: localize.formatAsFloat(more) }),
    },
    date: {
      min: ({ min }) =>
        t('Validation_DateMin', {
          min: formatDateToLocale(min, COMMON_DATE_FORMATS.DAY_MONTH_YEAR, language),
        }),
      max: ({ max }) =>
        t('Validation_DateMax', { max: formatDateToLocale(max, COMMON_DATE_FORMATS.DAY_MONTH_YEAR, language) }),
    },
  });
};
